import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// core components
import Grid from "@mui/material/Grid";

import { EstadoReserva, MessageOthelloBoxButtons, DialogOthelloResult, ModoModal, TiposInstalacionReserva } from "../othelloConstantes.jsx";
import { EstaCancelarDisponibleReserva, EstaCheckoutDisponibleReserva } from "../othelloFunciones.jsx";

import { Helmet } from 'react-helmet'
import MDBox from "../components/MDBox/index.js";
import MDTypography from "../components/MDTypography/index.js";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import reserva_cancel from "../assets/images/reserva_cancelar.jpg";
import reserva_checkout from "../assets/images/reserva_checkout.jpg";
import reserva_extender from "../assets/images/reserva_extender.jpg";

import TicketReservaInfo from "./TicketReservaInfo.jsx";
import ReservarAmpliar from "./ReservarAmpliar.js";
import OthelloMensaje from '../componentsothello/OthelloMensaje.jsx';
import OthelloModalBase from '../componentsothello/OthelloModalBase.jsx';

export default function TicketReserva({ ...props }) {
    const { } = props;

    //ejemplo url
    //https://reservas.ovtspain.es/ticket/reserva?id={Id_Oficina}-{Localizador}&data={dataencodedbase64}"

    const navigate = useNavigate();

    const { search } = useLocation();

    const [loading, setLoading] = React.useState(true);

    const [idofi, setidofi] = React.useState(-1);
    const [localizador, setlocalizador] = React.useState(-1);
    const [data, setdata] = React.useState(null);
    const [ticket, setticket] = React.useState(null);   

    const [stateModalEliminar, setstateModalEliminar] = React.useState(null);
    const [stateModalCheckOut, setstateModalCheckOut] = React.useState(null);
    const [stateModalAmpliar, setstateModalAmpliar] = React.useState(null);    

    React.useEffect(() => {

        let url = search;
        let params = new URLSearchParams(url);

        let identificador = params.get('id');
        let dt = params.get('data');        

        let idsplit = identificador.split('-');

        setidofi(idsplit[0]);
        setlocalizador(idsplit[1]);      

        setdata(dt);
        
        getDataPage(idsplit[0], idsplit[1], dt);
    }, [loading]);

    const getDataPage = (idofi, locali, data) => {
        if (idofi != null && data != null && locali != null)
        {
            var jsonData = JSON.stringify({ idofi: idofi, localizador: locali, data: data });
        
            fetch('api/Data/GetReservaTicket', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res != null) {
                    setticket(res);
                    setLoading(false);
                }
                else {
                    setticket({ id_ticket: -1 });
                    setLoading(false);
                }
            }).catch(error => {
                setticket({ id_ticket: -1 });
                setLoading(false);
            });
        }
    }
      
    const othelloModalResulEliminar = (modo, result, valor) => {
        if (result == DialogOthelloResult.OK)
            deleteReservas();

        setstateModalEliminar(null);
    }

    //METOSO SOBRE EL GRID DE RESERVAS
    const deleteReservas = () =>
    {
        if (EstaCancelarDisponibleReserva(ticket.reserva, ticket.instalacion.tipo)) {
            var jsonData = JSON.stringify({ Id_Oficina: ticket.reserva.id_Oficina, Id_Usuario: ticket.reserva.id_Usuario, localizador: ticket.reserva.localizador });

            fetch('api/Data/EliminarReservaLocalizador', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res)
                    getDataPage(idofi, localizador, data);
            }).catch(error => {
            });
        }
    }

    const othelloModalResulCheckOut = (modo, result, valor) =>
    {
        if (result == DialogOthelloResult.OK)
            doCheckOutReservas();

        setstateModalCheckOut(null);
    }

    //METOSO SOBRE EL GRID DE RESERVAS
    const doCheckOutReservas = () =>
    {
        if (EstaCheckoutDisponibleReserva(ticket.reserva, ticket.instalacion.tipo, ticket.instalacion.conCheckOutHoraria)) {
            var jsonData = JSON.stringify({ Id_Oficina: ticket.reserva.id_Oficina, id_instalacion: ticket.reserva.id_Instalacion, localizador: ticket.reserva.localizador });               

            fetch('api/Data/DoCheckOutReserva', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res)
                    getDataPage(idofi, localizador, data);
            }).catch(error => {
            });
        }
    }

    const othelloModalResulAmpliar = (modo, result, valor) =>
    {
        if (result == DialogOthelloResult.OK) 
            getDataPage(idofi, localizador, data);               

        setstateModalAmpliar(null);
    }

    const onClickOpcioneInstalacion = (id) => {
        if (id == "cancelar")
            setstateModalEliminar(true);
        else if (id == "checkout") 
            setstateModalCheckOut(true);
        else if (id == "ampliar") 
            setstateModalAmpliar(true);        
    }

    function renderItemOpcionesRserva(id, nameopc, descripcionopc, image, disable) {
        return (
            <Grid item xs={12}>
                <MDBox mx={1} my={2}>
                    <Card
                        onClick={() => {
                            if (!disable) {                               
                                onClickOpcioneInstalacion(id)
                            }
                        }}
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            height: 150,
                            borderRadius: 3,
                            overflow: 'hidden',
                            cursor: disable ? 'not-allowed' : 'pointer',
                            opacity: disable ? 0.5 : 1,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                            transition: 'all 0.3s ease',
                            '&:hover': disable
                                ? {}
                                : {
                                    boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
                                    transform: 'translateY(-2px)',
                                },
                        }}
                    >
                        {/* Imagen a la izquierda */}
                        <MDBox
                            sx={{
                                width: '40%',
                                height: '100%',
                                backgroundImage: `url(${image})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundColor: '#f0f0f0',
                            }}
                        />

                        {/* Texto a la derecha */}
                        <MDBox
                            sx={{
                                width: '60%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                px: 2,
                                py: 1.5,
                                backgroundColor: '#ffffff',
                            }}
                        >
                            <MDTypography
                                variant="h6"
                                fontWeight="medium"
                                textTransform="capitalize"
                                sx={{
                                    mb: 0.5,
                                    color: '#111827',
                                }}
                            >
                                {nameopc}
                            </MDTypography>

                            <MDTypography
                                variant="body2"
                                sx={{
                                    fontSize: 14,
                                    color: '#4b5563',
                                }}
                            >
                                {descripcionopc}
                            </MDTypography>
                        </MDBox>
                    </Card>
                </MDBox>
            </Grid>
        );
    }

    function renderOpcionesReserva(instalacion)
    {
        if (instalacion != null)
        {   
            //Compruebo que se puede cancelar
            let diaok = EstaCancelarDisponibleReserva(ticket.reserva, instalacion.tipo);

            //y ahora el checkout
            let checkoutenabled = EstaCheckoutDisponibleReserva(ticket.reserva, instalacion.tipo, instalacion.conCheckOutHoraria);

            let ampliarenabled = EstaCheckoutDisponibleReserva(ticket.reserva, instalacion.tipo, 1);
         
            return <Card sx={{ position: "sticky", top: 80, p: 0, mt: 2, mr: 2 }}>
                {instalacion != null && instalacion.image != "" ?
                    <img
                        src={instalacion.image}
                        alt="Instalacion"
                        style={{
                            width: "100%",
                            height: "150px",
                            objectFit: "cover",
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px"
                        }}
                    />
                    : ""}
                <CardContent>
                    <MDTypography variant="h5" fontWeight="bold" gutterBottom mt={1}>
                        Operaciones Reserva
                    </MDTypography>
                    {/* Toggle: aplicar c�digo */}
                    <MDBox mt={2}>
                        {renderItemOpcionesRserva("cancelar", "Cancelar Reserva", "Cancele su reserva si es su deseo de una manera agil.", reserva_cancel, !diaok)}
                        {renderItemOpcionesRserva("checkout", "Check-Out Reserva", "Realice el check-out de su reserva", reserva_checkout, !checkoutenabled)}
                        {renderItemOpcionesRserva("ampliar", "Ampliar Reserva", "Amplie su reserva con unos simples pasos.", reserva_extender, !ampliarenabled)}
                    </MDBox>
                </CardContent>
            </Card>
        }
        else return "";
    }

    function renderModalAmpliarReserva() {
        return (<OthelloModalBase titulo="Ampliar Reserva" open={true} onCloseResulModal={othelloModalResulAmpliar} botones={MessageOthelloBoxButtons.None} maxWidth="xl">
            <ReservarAmpliar instalacion={ticket != null ? ticket.instalacion : null} reserva={ticket != null ? ticket.reserva : null} onModalResulAmpliar={othelloModalResulAmpliar} desdeticketreserva={true} modoexterno={true} />
            </OthelloModalBase>);
    }


    let modalEliminarReserca = "";

    //Si el estado del modal es distinto de cerrado
    if (stateModalEliminar != null)
        modalEliminarReserca = <OthelloMensaje tituloliteral="ATMovilidad" descrip="Estas seguro de cancelar la reserva?" modo={ModoModal.SinDefinir} open={true} onCloseResulModal={othelloModalResulEliminar} botones={MessageOthelloBoxButtons.OKCancel} />

    let modalCheckoutReserca = "";

    //Si el estado del modal es distinto de cerrado
    if (stateModalCheckOut != null)
        modalCheckoutReserca = <OthelloMensaje tituloliteral="ATMovilidad" descrip="Estas seguro de hacer el Check-Out la reserva?" modo={ModoModal.SinDefinir} open={true} onCloseResulModal={othelloModalResulCheckOut} botones={MessageOthelloBoxButtons.OKCancel} />

    let modalAmpliarReserca = "";

    //Si el estado del modal es distinto de cerrado
    if (stateModalAmpliar != null)
        modalAmpliarReserca = renderModalAmpliarReserva();
     
    let cargando = loading ? <p><CircularProgress color="secondary" /></p> : "";       

    return (
        <div>
            <Helmet>
                <title>{!loading ? ticket.nombreoficinashow : "Ticket"}</title>
            </Helmet>            
            {modalEliminarReserca}
            {modalCheckoutReserca}
            {modalAmpliarReserca}
            <Grid item xs={12}>
                {Boolean(!loading && ticket?.imagebannerreservas) && (
                    <Grid container>
                        <Grid item xs={12}>
                            <MDBox
                                component="img"
                                src={ticket.imagebannerreservas}
                                alt="Banner Reservas"
                                sx={{
                                    width: '100%',
                                    height: {
                                        xs: 150,
                                        sm: 180,
                                        md: 250,
                                        lg: 300,
                                        xl: 350
                                    },
                                    objectFit: 'cover',
                                    border: '0.5px solid #eeeeee',
                                    borderRadius: 1,
                                    mb: 2,
                                }}
                            />
                        </Grid>
                    </Grid>
                )}
            </Grid>
            <MDBox px={2} py={1}>
                <Card variant="outlined" sx={{ pt: 2, backgroundColor: "#f9f9f9" }} >
                    <CardContent>                     
                        <MDTypography variant="h5" fontWeight="bold" gutterBottom mt={0}>
                                <center><h1>{!loading ? ticket.nombreoficinashow : ""}</h1></center>
                        </MDTypography>
                    </CardContent>
                </Card>
            </MDBox>  
            {loading ? cargando :
                <Grid container>
                    <Grid item xs={12} md={8}>
                        <TicketReservaInfo reserva={ticket != null ? ticket.reserva : null} infouso={ticket != null ? ticket.infouso : ""} modoexterno={true} id_Rol={null} desdeticketreserva={true}  />                        
                    </Grid>
                    <Grid item xs={12} md={4}>
                        {renderOpcionesReserva(ticket.instalacion)}
                    </Grid>                    
                </Grid>
            }            
        </div>
    );
}
